/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Use_PromptInputs */

const en_check_in_use_prompt = /** @type {(inputs: Check_In_Use_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use in generator`)
};

const es_check_in_use_prompt = /** @type {(inputs: Check_In_Use_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar en el generador`)
};

/**
* | output |
* | --- |
* | "Use in generator" |
*
* @param {Check_In_Use_PromptInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_use_prompt = /** @type {((inputs?: Check_In_Use_PromptInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Use_PromptInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_use_prompt(inputs)
	return es_check_in_use_prompt(inputs)
});